// Copyright (c) StrangeBee 2024

import { ICONS } from '@Constants/iconsApp';
import ExternalLink from '@Atoms/ExternalLink/ExternalLink';
import { Space } from 'antd';
import React, { ReactElement } from 'react';

export const PluginReference = (): ReactElement => {
    return (
        <ExternalLink
            className="button button-type-reference"
            url="https://github.com/adam-p/markdown-here/wiki/Markdown-Cheatsheet"
            title="Reference"
        >
            <Space size="small">
                <ICONS.QuestionCircleOutlined />
            </Space>
        </ExternalLink>
    );
};

PluginReference.align = 'right';
PluginReference.pluginName = 'reference';
